var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreatWallScroller = function SvgGreatWallScroller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.658 33.748h5.5v-32.5h-32.5v5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.158 6.748h32.5v32.5h-32.5z"
  })));
};
export default SvgGreatWallScroller;